import React from 'react';
import SEO from '../components/SEO';
import ContactInfo from '../components/ContactInfo';
import ContactFormTile from '../components/ContactFormTile';
import contactData from '../data/contact.json';
import seoData from '../data/seo.json';

const Contact = () => {
    return (
        <div className="pt-36 container mx-auto px-4 mb-20">
            <SEO page="contact" />
            
            <div className="mx-auto">
                <h1 className="text-4xl font-bold mb-4 text-center animate-fade-in opacity-0">{contactData.pageTitle}</h1>
                <p className="text-text-light text-center mb-8 animate-fade-in opacity-0 animation-delay-100">
                    Available 24/7 for emergency plumbing and heating services in Calgary
                </p>

                {/* Emergency Banner */}
                <div className="glass-panel p-6 mb-12 text-center bg-gradient-to-r from-red-500/10 to-red-400/10 border-red-400/30 animate-fade-in opacity-0 animation-delay-200">
                    <p className="text-xl md:text-2xl font-bold text-text-dark mb-3">🚨 Need Emergency Help?</p>
                    <a 
                        href={`tel:${seoData.business.phone.replace(/[^0-9]/g, '')}`}
                        className="inline-block glass-button text-xl px-8 py-4"
                    >
                        Call Now: {seoData.business.phone}
                    </a>
                </div>

                <div className="grid md:grid-cols-2 gap-12">
                    {/* Contact Info */}
                    <ContactInfo
                        title={contactData.contactInfoTitle}
                        contactDetails={contactData.contactDetails}
                    />

                    {/* Contact Form */}
                    <ContactFormTile />
                </div>

                {/* Service Area Map Placeholder */}
                <div className="mt-12 glass-panel p-8 text-center animate-fade-in opacity-0">
                    <h2 className="text-2xl font-bold mb-4 text-text-dark">Our Service Area</h2>
                    <p className="text-text-light mb-6">
                        Proudly serving Calgary and surrounding communities including {seoData.business.serviceAreas.slice(0, 5).join(', ')}, and more.
                    </p>
                    <div className="flex flex-wrap justify-center gap-2">
                        {seoData.business.serviceAreas.map((area, index) => (
                            <span 
                                key={index}
                                className="px-3 py-1 bg-white/50 rounded-full text-sm text-text-dark border border-glass-border"
                            >
                                {area}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
